<template>
  <ul
    class="counselor-competence-list__list"
    :class="{ 'skeleton-loader': isLoading }"
    :style="isLoading ? { height: '100px' } : null"
  >
    <li
      class="counselor-competence-list__list-item"
      v-for="(option, index) in limitedOptions"
      :key="index"
    >
      {{ option }}
    </li>
    <li
      class="counselor-competence-list__list-item counselor-competence-list__list-item--show-all"
      v-if="options.length > maxItems && !showAll"
    >
      <button @click="showAll = !showAll">+ {{ showAllText }}</button>
    </li>
  </ul>
</template>

<script lang="ts">
import { useIsMobile } from 'Main/composables/useIsMobile';
import { useUser } from 'Main/composables/useUser';
import {
  TCaseType,
  TSchedule,
  TUserState,
} from 'Stores/modules/types/user.types';
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

export default defineComponent({

  computed: {
    ...mapState('cities', ['cityLinks']),
    ...mapState<{ user: TUserState }>('user', [
      'caseTypes',
      'schedule',
      'isLoading',
    ]),

    limitedOptions(): string[] {
      if (this.showAll) {
        return this.options;
      }
      return this.options.slice(0, this.maxItems);
    },

    maxItems(): number {
      return this.isMobile ? 10 : 14;
    },

    options(): string[] {
      if (!this.caseTypes) {
        return [];
      }

      const caseTypes = this.caseTypes as TCaseType[];

      switch (this.role) {
        case 'funeral-advisor':
          return caseTypes
            .filter((caseType) => caseType.type === 'FUNERAL')
            .map((caseType) => caseType.name);
        case 'jurist':
          return caseTypes
            .filter((caseType) => caseType.type === 'LEGAL')
            .map((caseType) => caseType.name);
        case 'therapist':
          return caseTypes
            .filter((caseType) => caseType.type === 'THERAPY')
            .map((caseType) => caseType.name);
        default:
          return [];
      }
    },

    scheduleLength(): number {
      return (this.schedule as TSchedule[])?.length || 0;
    },
  },

  created() {
    this.maybeFetchUser(this.advisorId, this.scheduleLength > 0);
  },

  data() {
    const dataset = (this.$mountEl as HTMLElement).dataset;

    return {
      advisorId: dataset.advisorId || '',
      expertiseText: window.theme_vars.counselorProfileTexts.expertise,
      role: dataset.role || '',
      showAll: false,
      showAllText: window.theme_vars.counselorSlider.showAll,
    };
  },
  name: 'CounselorCompetences',

  setup() {
    const { isMobile, isTablet } = useIsMobile();
    const { maybeFetchUser, getUpdatedSchedule } = useUser();
    return { getUpdatedSchedule, isMobile, isTablet, maybeFetchUser };
  },
});
</script>
